import { Link } from 'react-router-dom';
import { featuredMovies } from '@/mocks/movies';

export default function FeaturedSection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">精选高分影视，不容错过</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap transition-colors flex items-center gap-1 cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {featuredMovies.map((movie, index) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group relative rounded-lg overflow-hidden bg-background-50 border border-background-200/70 transition-all duration-300 hover:border-primary-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={movie.image}
                  alt={movie.title}
                  title={`${movie.title} - 春色影视高清在线观看`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3 bg-primary-500 text-background-50 text-xs font-bold px-2.5 py-1 rounded whitespace-nowrap">
                  {index === 0 ? '热播中' : index === 1 ? '新上线' : '推荐'}
                </div>
                <div className="absolute top-3 right-3 bg-background-950/75 text-accent-400 text-sm font-bold px-2.5 py-1 rounded whitespace-nowrap">
                  {movie.rating}
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <h3 className="text-base md:text-lg font-bold text-white truncate">{movie.title}</h3>
                  <div className="flex items-center gap-2 mt-2 text-xs text-white/70 flex-wrap">
                    <span>{movie.category}</span>
                    <span>·</span>
                    <span>{movie.year}</span>
                    <span>·</span>
                    <span>{movie.duration}</span>
                  </div>
                  <p className="mt-2 text-xs text-white/60 line-clamp-2">{movie.description}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}